// extracted by mini-css-extract-plugin
export default {"OfferForm":"OfferForm_OfferForm__2wpnH"};